import { useEffect, useState } from "react";
import { mastheadTabs } from "@/mocks/home";

export default function Masthead() {
  const [now, setNow] = useState<string>("");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const pad = (n: number) => String(n).padStart(2, "0");
    const tick = () => {
      const d = new Date();
      const weekday = "日一二三四五六"[d.getDay()];
      setNow(
        `${d.getFullYear()}年${d.getMonth() + 1}月${d.getDate()}日 周${weekday} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
      );
    };
    tick();
    const t = window.setInterval(tick, 1000);
    return () => window.clearInterval(t);
  }, []);

  const anchors = [
    { id: "timeline", label: mastheadTabs[0] },
    { id: "live", label: mastheadTabs[1] },
    { id: "scene", label: mastheadTabs[2] },
    { id: "trust", label: mastheadTabs[3] },
  ];

  return (
    <header className="relative z-30 bg-paper/95">
      {/* utility strip */}
      <div className="border-b border-line">
        <div className="mx-auto flex max-w-6xl flex-col gap-2 px-4 py-2 text-xs text-muted sm:flex-row sm:items-center sm:justify-between md:px-6">
          <div className="flex items-center gap-2 whitespace-nowrap">
            <span className="inline-flex h-1.5 w-1.5 animate-pulse rounded-full bg-accent" />
            <span className="tracking-wide">正在发生 · 第一轮现场</span>
          </div>
          <div className="flex items-center gap-4 whitespace-nowrap">
            <span className="tabular-nums">{now}</span>
            <span className="hidden items-center gap-1 sm:flex">
              <i className="ri-radio-2-line text-[13px]" /> 发稿轮次 · 第 214 轮
            </span>
          </div>
        </div>
      </div>

      {/* masthead */}
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex items-center justify-between py-5 md:py-6">
          <h1 className="m-0 text-ink">
            <a href="#top" className="flex items-end gap-0.5">
              <span className="font-display text-4xl font-black leading-none tracking-tight md:text-5xl">
                911
              </span>
              <span className="font-display text-xl font-semibold leading-none text-accent md:text-2xl">
                网
              </span>
            </a>
          </h1>

          <div className="flex items-center gap-7">
            <nav className="hidden items-center gap-7 md:flex">
              {anchors.map((a) => (
                <a
                  key={a.id}
                  href={`#${a.id}`}
                  className="whitespace-nowrap text-sm text-muted transition-colors hover:text-accent"
                >
                  {a.label}
                </a>
              ))}
            </nav>
            <a
              href="#scene"
              className="hidden whitespace-nowrap rounded-md bg-accent px-4 py-2 text-sm text-white transition-colors hover:bg-accent-deep md:inline-flex"
            >
              进站看现场
            </a>
            <button
              type="button"
              aria-label="菜单"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-line text-lg text-ink md:hidden"
            >
              <i className={open ? "ri-close-line" : "ri-menu-3-line"} />
            </button>
          </div>
        </div>
      </div>

      {/* mobile menu */}
      {open && (
        <nav className="flex flex-col gap-1 border-t border-line pb-4 md:hidden">
          {anchors.map((a) => (
            <a
              key={a.id}
              href={`#${a.id}`}
              onClick={() => setOpen(false)}
              className="whitespace-nowrap border-b border-line py-3 text-sm text-ink last:border-0"
            >
              {a.label}
            </a>
          ))}
        </nav>
      )}
    </header>
  );
}